import {useQuery, UseQueryOptions, UseQueryResult} from '@tanstack/react-query';
import {fetchBusinessIncentives} from '~/modules/BusinessIncentives/api';
import {IBusinessIncentive} from '~/modules/BusinessIncentives/models/BusinessIncentive';

export const BUSINESS_INCENTIVES_QUERY_KEY = ['business-incentives'] as const;

const queryDefaults = {
    staleTime: 60_000,
    gcTime: 10 * 60_000,
} as const;

export const useBusinessIncentivesQuery = (
    options?: Omit<UseQueryOptions<IBusinessIncentive[]>, 'queryKey' | 'queryFn'>
): UseQueryResult<IBusinessIncentive[]> =>
    useQuery<IBusinessIncentive[]>({
        queryKey: BUSINESS_INCENTIVES_QUERY_KEY,
        queryFn: fetchBusinessIncentives,
        ...queryDefaults,
        ...options,
    });
